import { useBreadcrumbs } from 'hooks/use-breadcrumbs';

type Crumb = {
	href: string, 
	title: string, 
	isHidden?: boolean, 
	id: number,
}

export type ReplaceCrumb = {
	href?: string;
	title?: string | null;
	isHidden?: boolean;
}

type SetBreadcrumbsProps = {
	baseName?: string,
	replace?: Map<string, ReplaceCrumb>,
}

export const useSetBreadcrumbs = () => {
	const generateSpecificBreadcrumbs = ({baseName, replace}: SetBreadcrumbsProps) => {
		const updatedBreadCrumbs: Crumb[] = [];
		const { generateNextBreadcrumbs } = useBreadcrumbs();

		const breadcrumbs = generateNextBreadcrumbs({ baseName });

		breadcrumbs.forEach(breadcrumb => {
			if(replace && replace?.has(breadcrumb?.href)) {
				updatedBreadCrumbs.push({
					...breadcrumb, 
					...(replace?.get(breadcrumb.href)?.title && { title: replace?.get(breadcrumb.href)?.title || ''}),
					...(replace?.get(breadcrumb.href)?.href && { href: replace?.get(breadcrumb.href)?.href || ''}),
					...(replace?.get(breadcrumb.href)?.isHidden && { isHidden: replace?.get(breadcrumb.href)?.isHidden} || false),
				});
				return;
			}
			updatedBreadCrumbs.push(breadcrumb);
		})

		return updatedBreadCrumbs;
	}

	return { generateSpecificBreadcrumbs };
};
